// src/UserContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { UserRole } from './roles';

interface UserContextType {
    userRole: UserRole | null;
    setUserRole: (role: UserRole) => void;
    isAuthenticated: boolean;
    setIsAuthenticated: (isAuthenticated: boolean) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
        return sessionStorage.getItem("isAuthenticated") === "true";
    });
    const [userRole, setUserRole] = useState<UserRole | null>(() => {
        try {
            const profile = sessionStorage.getItem("profile");
            if (!profile) return null;
            const parsed = JSON.parse(profile);
            return parsed?.role || parsed?.profile?.role || null;
        } catch {
            return null;
        }
    });

    return (
        <UserContext.Provider value={{ userRole, setUserRole, isAuthenticated, setIsAuthenticated }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
